import { render, staticRenderFns } from "./softArticle.vue?vue&type=template&id=120fb6dc&scoped=true&"
import script from "./softArticle.vue?vue&type=script&lang=js&"
export * from "./softArticle.vue?vue&type=script&lang=js&"
import style0 from "./softArticle.vue?vue&type=style&index=0&id=120fb6dc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120fb6dc",
  null
  
)

export default component.exports